import {getCollapsedGroupsData} from './collapsedGroups';
import {homepageStore} from '../store/HomepageStore';
import {requestHomepageData} from '../api';

export const getHomepageData = async (requestHiddenGroupsData?: boolean) => {
    const [data] = await Promise.all([
        requestHomepageData(),
        (async () => {
            if (requestHiddenGroupsData) {
                const collapsedData = await getCollapsedGroupsData();
                homepageStore.setCollapsedGroups(collapsedData);
            }
        })()
    ]);

    const res = (data as any)?.General?.[0]?.Menu || [];
    homepageStore.setItems(res);

    return res;
};
